<template>
    <section class="pop-form pop-sign-log third-register">
        <hgroup>
            <h2>{{ $t('common:thirdRegister.registerTitle') }}</h2>
            <p>
                {{ $t('common:thirdRegister.registerSubTitle') }}
            </p>
        </hgroup>
        <v-form
            :onSubmit="thirdRegisterSubmit"
            :onSuccess="thirdRegisterSubmitSuccess"
            :onError="thirdRegisterSumbitError"
            ref="form"
        >
            <p>{{ $t('common:fullName') }}</p>
            <div class="name">
                <input
                    readonly
                    :value="fullname"
                    autocomplete="off"
                    type="text"
                    name="fullname"
                />
                <span class="checked">
                    <i class="iconfont icon-checked"></i>
                </span>
            </div>
            <v-input
                v-if="!email"
                name="email"
                type="email"
                :placeholder="$t('common:emailAddress') + '*'"
                required
                focus
                clearable
                :validateConfig="{
                    async: '/api-site/register/hasUser?account={value}',
                    'async-callback': hasUserCallBack
                }"
                @input="onTrackEmail(regType.email)"
            >
                <p class="next-p">{{ $t('common:emailAddress') }}</p>
            </v-input>
            <template v-else>
                <p class="next-p">{{ $t('common:emailAddress') }}</p>
                <div class="email">
                    <input
                        readonly
                        :value="email"
                        autocomplete="off"
                        type="email"
                        name="email"
                    />
                    <span class="checked">
                        <i class="iconfont icon-checked"></i>
                    </span>
                </div>
            </template>
            <v-input
                class="phone"
                name="phone"
                type="tel"
                :focus="!!email"
                :placeholder="$t('common:phone') + (phoneRequired ? '*' : '')"
                :required="phoneRequired"
                clearable
                :validateConfig="{
                    async: '/api-site/phoneValidate?phoneNumber={value}'
                }"
                @input="onTrackPhone(regType.phone)"
            >
                <p class="next-p">{{ $t('common:phone') }}</p>
            </v-input>
            <disclaimer :disclaimerUniqId="disclaimerUniqId" @updateChecked="updateChecked" class="pop-register-disclaimer" color="#505050" :btnText="$t('common:thirdRegister.submitText')" />
            <div :class="{'submit':true, disabled:disclaimerSubmitDisabled}" :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''">
                <input
                    type="submit"
                    :value="$t('common:thirdRegister.submitText')"
                />
            </div>
            <p v-show="thirdPartErrorShow" class="mg-error">
                {{ thirdPartErrorMsg }}
            </p>
        </v-form>
    </section>
</template>

<script>
import vFormVue from '../../v-form.vue';
import vInputVue from '../../v-input.vue';
import track from '../third-register-track-mixins';
export default {
    mixins: [track],
    props: {
        fullname: {
            type: String,
            default: ''
        },
        email: {
            type: String,
            default: ''
        },
        phoneRequired: {
            type: Boolean,
            default: true
        },
        thirdPartErrorShow: {
            type: Boolean,
            default: false
        },
        thirdPartErrorMsg: {
            type: String,
            default: ''
        },
        thirdRegisterSubmit: Function,
        thirdRegisterSubmitSuccess: Function,
        thirdRegisterSumbitError: Function
    },
    components: {
        'v-form': vFormVue,
        'v-input': vInputVue
    }
};
</script>
